import React from "react";
import { StaticQuery, graphql } from "gatsby";
import styled from "styled-components";

const StyledFooter = styled.footer`
  background: rgb(27, 31, 59);
  padding: 10px;
  color: rgb(220, 220, 220);
  text-align: center;
  font-size: 14px;

  a {
    color: #c874d9;
  }
`;

const Footer = () => (
  <StaticQuery
    query={graphql`
      query FooterQuery {
        site {
          siteMetadata {
            company
          }
        }
      }
    `}
    render={data => (
      <StyledFooter>
        <div className="bg-blue-500">
          <p>
            World Data and US data sourced from:{" "}
            <a href="https://github.com/CSSEGISandData/COVID-19">
              Johns Hopkins CSSE - Github
            </a>
          </p>

          <p>
            Huge shoutouts: <br />
            World Data API from:{" "}
            <a href="https://github.com/novelcovid/api">
              https://github.com/novelcovid/api
            </a>
            , US testing data/API from:{" "}
            <a href="https://covidtracking.com/about-data">
              The COVID Tracking Project
            </a>
          </p>

          <p>
            Data parsed, calculated/aggregated, and graphed by me:{" "}
            <a
              href="https://www.stoutlabs.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              {data.site.siteMetadata.company}
            </a>
          </p>

          <p>
            <a
              href="https://ko-fi.com/P5P51LAKV"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                height="36"
                style={{ border: 0, height: 36 }}
                src="https://cdn.ko-fi.com/cdn/kofi1.png?v=2"
                border="0"
                alt="Buy Me a Coffee at ko-fi.com"
              />
            </a>
          </p>
        </div>
      </StyledFooter>
    )}
  />
);

export default Footer;
